var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',_vm._b({attrs:{"show":_vm.isShow},on:{"change":_vm.onShowChangeHandler},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'Popup',_vm.popupProps,false),[_vm._t("dropdown")],2)}
var staticRenderFns = []

export { render, staticRenderFns }